import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FacilityService } from './facility.service';

@Injectable({
  providedIn: 'root'
})
export class FacilityResolve {

  constructor(
    private fs: FacilityService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.fs.updateFacility(route.params.id)
  }
}
